import { render, staticRenderFns } from "./TMenuItem.vue?vue&type=template&id=0fe0e38a&scoped=true&"
import script from "./TMenuItem.vue?vue&type=script&lang=js&"
export * from "./TMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TMenuItem.vue?vue&type=style&index=0&id=0fe0e38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0e38a",
  null
  
)

export default component.exports